/*  eslint-disable class-methods-use-this */
export class Search {
	constructor(data, id, inputId) {
		this.currentData = data;
		this.id = id;
		this.inputId = inputId;
		this.data = data;
		this.element = document.querySelector('.search');
		this.input = document.getElementById(this.inputId);
		this.openBtn = document.querySelector('.js-search-open');
		this.closeBtn = document.querySelector('.js-search-close');
		this.label = document.querySelector('.search__placeholder');
		this.searchWrapper = this.element;
		this.s = document.querySelector('.search__item');

		this.getData();

		this.input.addEventListener('input', this.search.bind(this));
		this.input.addEventListener('blur', this.hideResult.bind(this));
		this.element.addEventListener('click', this.handler.bind(this));

		if (this.openBtn) {
			this.openBtn.addEventListener('click', this.open.bind(this));
		}

		if (this.closeBtn) {
			this.closeBtn.addEventListener('click', this.close.bind(this));
		}
	}

	getData(data = this.currentData) {
		const result = document.getElementById(this.id);
		const newResultwrapper = document.createElement('div');
		const textElement = document.createElement('span');

		result.remove();
		newResultwrapper.id = this.id;
		newResultwrapper.classList.add('search__result');

		this.searchWrapper.appendChild(newResultwrapper);

		textElement.classList.add('search__noresult', 'no-result');
		textElement.innerHTML = `
			По запросу ничего не найдено.
		`;
		newResultwrapper.appendChild(textElement);

		for (let i = 0; i < data.length; i++) {
			const newElement = document.createElement('a');
			newElement.href = data[i].url;
			newElement.classList.add('search__item');

			newElement.innerHTML = `
				<span class="search__name">${data[i].name}</span>&nbsp;
				<span class="search__location">(${data[i].location})</span>
			`;
			newResultwrapper.appendChild(newElement);
		}
	}

	search() {
		let count = 0;
		let value = this.input.value.toUpperCase();
		let result = document.getElementById(this.id);
		let elements = result.querySelectorAll('.search__item');
		let noresult = result.querySelector('.search__noresult');

		for (let i = 0; i < elements.length; i++) {
			let name = elements[i].querySelector('.search__name');

			if (name) {
				let nameValue = name.textContent || name.innerText;

				if (nameValue.toUpperCase().includes(value)) {
					elements[i].style.display = '';
					elements[i].classList.add('search__item--show');
				} else {
					elements[i].style.display = 'none';
					elements[i].classList.remove('search__item--show', 'search__item--last');
					count++;
				}
			}

			if (count === elements.length) {
				noresult.classList.add('is-visible');
			} else {
				noresult.classList.remove('is-visible');
			}
		}

		let elementsShow = result.querySelectorAll('.search__item--show');
		let elementShow = result.querySelector('.search__item--show');
		let elementShowLast = elementsShow[elementsShow.length - 1];

		if (elementShow) {
			elementShowLast.classList.add('search__item--last');
		}

		this.toogleResult(value);
	}

	toogleResult(value) {
		const result = document.getElementById(this.id);

		if (value.length >= 1) {
			result.classList.add('is-visible');
			this.label.classList.add('is-active');
		} else {
			result.classList.remove('is-visible');
			this.label.classList.remove('is-active');
		}
	}

	showResult(value) {
		const result = document.getElementById(this.id);

		if (value.length >= 1) {
			result.classList.add('is-visible');
		}

		this.label.classList.add('is-active');
	}

	hideResult() {
		const result = document.getElementById(this.id);

		setTimeout(() => {
			result.classList.remove('is-visible');
		}, 600);

		if (this.input.value === 0) {
			this.label.classList.remove('is-active');
		}
	}

	close(e) {
		e.preventDefault();
		this.input.value = '';
		this.label.classList.remove('is-active');

		if (this.element.closest('.header')) {
			this.element.closest('.header').classList.remove('is-open-search');
		}

		this.clearList();
	}

	open(e) {
		e.preventDefault();

		if (this.element.closest('.header')) {
			this.element.closest('.header').classList.add('is-open-search');
		}
	}

	clean() {
		this.close();
		this.hideResult();
	}

	handler(e) {
		if (e.target.classList.contains('search__item') || e.target.closest('.search__item')) {
			this.clean();
		}
	}

	clearList() {
		let listResult = document.querySelectorAll('.search__item');

		for (let i = 0; i < listResult.length; i++) {
			if (listResult[i].style.display === 'none') {
				listResult[i].style.display = '';
			}
		}
	}

	init() {
		// init
	}
}
